import { useState, type ChangeEvent } from 'react';
import { FormControlLabel, Checkbox, Typography } from '@mui/material';
import { AutocompleteStatesAndCities } from '@/components/partial/autocomplete-states-cities';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';
import type { RecommendationProfile } from '@/models/recommendation';

interface LocationInfoEditDialogProps {
  currentValues: Partial<RecommendationProfile>;
  onClose: () => void;
  onSave: (locationInfo: Partial<RecommendationProfile>) => void;
}

export const LocationInfoEditDialog = ({
  currentValues,
  onClose,
  onSave,
}: LocationInfoEditDialogProps) => {
  const [selectedLocationInfo, setSelectedLocationInfo] =
    useState<Partial<RecommendationProfile>>(currentValues);

  const handleSave = () => {
    onSave(selectedLocationInfo);
  };

  const onStateAndCityChange = (state: string, city: string) => {
    setSelectedLocationInfo({
      ...selectedLocationInfo,
      address_state: state,
      address_city: city,
    });
  };

  const handleNonResidentChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSelectedLocationInfo({
      ...selectedLocationInfo,
      non_resident: e.target.checked,
    });
  };

  return (
    <ConfirmDialog
      actionLabels={{
        cancel: 'Cancelar',
        confirm: 'Salvar',
      }}
      onClose={onClose}
      open
      onConfirm={handleSave}
      title="Localização"
    >
      <AutocompleteStatesAndCities
        initialState={selectedLocationInfo.address_state || ''}
        initialCity={selectedLocationInfo.address_city || ''}
        onStateAndCityChange={onStateAndCityChange}
        direction="column"
        disabled={!!selectedLocationInfo.non_resident}
      />
      <FormControlLabel
        control={
          <Checkbox
            onChange={handleNonResidentChange}
            checked={!!selectedLocationInfo.non_resident}
          />
        }
        label={<Typography>Não moro no Brasil</Typography>}
      />
    </ConfirmDialog>
  );
};
